import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResponseApi } from '../../../dtos/ResponseApi';
import { CreateNecessidadeEspecialDto } from '../../../dtos/core/necessidadeEspecial/CreateNecessidadeEspecialDto';
import { NecessidadeEspecialResponse } from '../../../dtos/core/necessidadeEspecial/NecessidadeEspecialResponse';

@Injectable({
  providedIn: 'root'
})
export class NecessidadeEspecialService {
  private baseUrl = `${environment.apiUrl}/core/NecessidadeEspecial`;

  constructor(private http: HttpClient) { }

  getAll(): Observable<ResponseApi<NecessidadeEspecialResponse[]>> {
    return this.http.get<ResponseApi<NecessidadeEspecialResponse[]>>(this.baseUrl);
  }

  create(request: CreateNecessidadeEspecialDto): Observable<ResponseApi<NecessidadeEspecialResponse>> {
    return this.http.post<ResponseApi<NecessidadeEspecialResponse>>(this.baseUrl, request);
  }
}
